module.exports = __webpack_public_path__ + "img/vegetarian.8555b337.svg";